import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { toast } from "react-toastify";
import { FaPlus, FaCheck, FaTimes } from "react-icons/fa";
import { useTypeConfig } from "../../../utils/useTypeConfig";
import { useCommonContext } from "../../../utils/context";
function LeadModal({
  show,
  handleClose,
  leadData,
  fetchLeadData,
  isUpdateStatus,
  fetchAllLeadData,
}) {
  const [loading, setLoading] = useState(false);
  const { fetchCustomers } = useCommonContext();
  const [errors, setErrors] = useState({});
  const { labels } = useTypeConfig();
  const [formData, setFormData] = useState({
    status: "",
  });

  const statusOptions = [
    { value: "Inactive", label: "Inactive" },
    { value: "Interact", label: "Interact" },
    { value: "In-Discussion", label: "In-Discussion" },
    { value: "Quote Sent", label: "Quote Sent" },

    { value: "Service Taken", label: "Service Taken" },
    { value: "Not Interested", label: "Not Interested" },
  ];

  const [isAddingSource, setIsAddingSource] = useState(false);
  const [sources, setSources] = useState([]);
  const [selectedSourceId, setSelectedSourceId] = useState("");
  const [newSource, setNewSource] = useState("");

  const fetchSources = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/lead-source/`, {
        headers: HEADERS,
      });
      if (response.data) {
        setSources(response.data);
      }
    } catch (error) {
      console.error("Error fetching sources:", error);
    }
  };

  const addNewSource = async () => {
    if (newSource.trim() === "") return;
    try {
      const response = await fetch(`${BASE_URL}/api/lead-source/`, {
        method: "POST",
        headers: {
          ...HEADERS,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: newSource }),
      });

      if (response.ok) {
        fetchSources();
        setFormData({ ...formData, source: newSource });
        setNewSource("");
        setIsAddingSource(false);
        toast.success("Source added successfully");
      } else {
        console.error("Failed to add new source");
      }
    } catch (error) {
      toast.error(error.response?.data?.error || "Error Please Try again.");
    }
  };

  const handleSourceChange = (e) => {
    const selectedId = e.target.value;
    const selectedSourceName = sources.find(
      (source) => source.id === parseInt(selectedId),
    )?.name;

    setSelectedSourceId(selectedId);
    setFormData({ ...formData, source: selectedSourceName });
  };

  const cancelNewSource = () => {
    setNewSource("");
    setIsAddingSource(false);
  };

  useEffect(() => {
    fetchSources();
  }, []);

  useEffect(() => {
    if (leadData && isUpdateStatus) {
      setFormData({ status: leadData.status || "" });
    } else if (leadData) {
      setFormData({
        companyName: leadData.companyName || "",
        firstName: leadData.firstName || "",
        // lastName: leadData.lastName || "",
        email: leadData.email || "",
        mobile: leadData.mobile || "",
        address: leadData.address || "",
        country: leadData.country || "",
        state: leadData.state || "",
        city: leadData.city || "",
        notes: leadData.notes || "",
        source: leadData.source || "",
        status: leadData.status || "",
      });
    } else {
      setFormData({
        companyName: "",
        firstName: "",
        // lastName: "",
        email: "",
        mobile: "",
        address: "",
        country: "",
        state: "",
        city: "",
        notes: "",
        source: "",
        status: "",
      });
    }
  }, [leadData, isUpdateStatus]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      if (name === "mobile") {
        const numericValue = value.replace(/\D/g, "").replace(/^0+/, "");
        return { ...prev, [name]: numericValue };
      } else {
        return { ...prev, [name]: value };
      }
    });

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};
    if (!formData.mobile?.trim()) {
      newErrors.mobile = "Phone number is required.";
      valid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Phone number must be 10 digits.";
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isUpdateStatus && !validateForm()) {
      return;
    }
    setLoading(true);

    const formDataToSubmit = { ...formData };

    try {
      if (leadData) {
        if (!isUpdateStatus) {
          delete formDataToSubmit.status;
        }
        await axios.put(
          `${BASE_URL}/api/leads/${leadData.id}/`,
          formDataToSubmit,
          { headers: { ...HEADERS } },
        );
        toast.success("Lead updated successfully.");
        if (formData.status === "Service Taken") {
          fetchCustomers();
        }
      } else {
        delete formDataToSubmit.status;
        await axios.post(`${BASE_URL}/api/leads/`, formDataToSubmit, {
          headers: { ...HEADERS },
        });
        toast.success("Lead created successfully.");
      }
      fetchLeadData();
      fetchAllLeadData();
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.error || "Error Please Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#f5f5f5", borderBottom: "1px solid #ddd" }}
      >
        <Modal.Title
          className="w-100 text-center"
          style={{ fontSize: "1.5rem", fontWeight: "bold" }}
        >
          {isUpdateStatus ? "Update Status" : "Lead Form"}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body style={{ padding: "2rem" }}>
          {isUpdateStatus ? (
            <Form.Group controlId="status" style={{ marginBottom: "1.5rem" }}>
              <Form.Label style={{ fontWeight: "bold", fontSize: "1rem" }}>
                Status
              </Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                required
                style={{ padding: "0.5rem", borderRadius: "4px" }}
              >
                {statusOptions?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          ) : (
            <>
              <h5
                className="mb-4"
                style={{ fontWeight: "bold", color: "#555" }}
              >
                Basic Information
              </h5>
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group controlId="companyName">
                    <Form.Control
                      type="text"
                      name="companyName"
                      placeholder={labels.companyName}
                      value={formData.companyName}
                      onChange={handleInputChange}
                      isInvalid={!!errors.companyName}
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.companyName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="firstName">
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder={labels.customerName}
                      value={formData.firstName}
                      onChange={handleInputChange}
                      isInvalid={!!errors.firstName}
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.firstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                {/* <Col md={4}>
                  <Form.Group controlId="lastName">
                    <Form.Control
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      isInvalid={!!errors.lastName}
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.lastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col> */}
              </Row>

              <h5
                className="mb-4"
                style={{ fontWeight: "bold", color: "#555" }}
              >
                Contact Details
              </h5>
              <Row className="mb-4">
                <Col md={4}>
                  <Form.Group controlId="email">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      isInvalid={!!errors.email}
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="mobile">
                    <Form.Control
                      type="text"
                      name="mobile"
                      placeholder="Mobile No."
                      value={formData.mobile}
                      onChange={handleInputChange}
                      isInvalid={!!errors.mobile}
                      required
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.mobile}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="address">
                    <Form.Control
                      type="text"
                      name="address"
                      placeholder="Address"
                      value={formData.address}
                      onChange={handleInputChange}
                      isInvalid={!!errors.address}
                      required
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.address}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={4}>
                  <Form.Group controlId="country">
                    <Form.Control
                      type="text"
                      name="country"
                      placeholder="Country"
                      value={formData.country}
                      onChange={handleInputChange}
                      isInvalid={!!errors.country}
                      required
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.country}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="state">
                    <Form.Control
                      type="text"
                      name="state"
                      placeholder="State"
                      value={formData.state}
                      onChange={handleInputChange}
                      isInvalid={!!errors.state}
                      required
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="city">
                    <Form.Control
                      type="text"
                      name="city"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleInputChange}
                      isInvalid={!!errors.city}
                      required
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group controlId="notes">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="notes"
                      placeholder="Additional Notes"
                      value={formData.notes}
                      onChange={handleInputChange}
                      isInvalid={!!errors.notes}
                      style={{ padding: "0.5rem", borderRadius: "4px" }}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.notes}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="source">
                    <div
                      className="input-group"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {!isAddingSource ? (
                        <>
                          <Form.Control
                            as="select"
                            name="source"
                            value={selectedSourceId}
                            onChange={handleSourceChange}
                            isInvalid={!!errors.source}
                            style={{ padding: "0.5rem", borderRadius: "4px" }}
                          >
                            <option value="">Select Source</option>
                            {Array.isArray(sources) && sources.length > 0 ? (
                              sources.map((source) => (
                                <option key={source.id} value={source.id}>
                                  {source.name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No sources available</option>
                            )}
                          </Form.Control>

                          <div className="input-group-append">
                            <span
                              className="input-group-text"
                              onClick={() => setIsAddingSource(true)}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                padding: "0 0.5rem",
                              }}
                            >
                              <FaPlus />
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <Form.Control
                            type="text"
                            placeholder="Add new source"
                            value={newSource}
                            onChange={(e) => setNewSource(e.target.value)}
                            required
                            isInvalid={!!errors.newSource}
                            style={{ padding: "0.5rem", borderRadius: "4px" }}
                          />
                          <div className="input-group-append">
                            <span
                              className="input-group-text"
                              onClick={addNewSource}
                              style={{
                                cursor: "pointer",
                                color: "green",
                                display: "flex",
                                alignItems: "center",
                                padding: "0 0.5rem",
                              }}
                            >
                              <FaCheck />
                            </span>
                          </div>
                          <div className="input-group-append">
                            <span
                              className="input-group-text"
                              onClick={cancelNewSource}
                              style={{
                                cursor: "pointer",
                                color: "red",
                                display: "flex",
                                alignItems: "center",
                                padding: "0 0.5rem",
                              }}
                            >
                              <FaTimes />
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer
          style={{ backgroundColor: "#f5f5f5", borderTop: "1px solid #ddd" }}
        >
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default LeadModal;
